export async function subscribeUser(email) {
    if (!("serviceWorker" in navigator)) {
        console.log("Service workers are not supported in this browser.");
        return;
    }

    const registration = await navigator.serviceWorker.ready;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
        console.log("Permission not granted for Notification");
        return;
    }

    // Fetch public key from backend
    const response = await fetch(`${process.env.REACT_APP_API_URL}/vapidPublicKey`);
    const { publicKey } = await response.json();

    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
    });

    await fetch(`${process.env.REACT_APP_API_URL}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, subscription })
    });

    console.log("✅ Push notifications enabled!");
}

// Helper function
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}
